import { render } from "./designOcrPrint.vue?vue&type=template&id=d2a23cf0"
import script from "./designOcrPrint.vue?vue&type=script&lang=js"
export * from "./designOcrPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__